import { SeasonKey } from 'modules/SugarcaneMapView/seasonsConfig';

export const SUGARCANE_SEASON_ID_MAP: Record<string, SeasonKey> = {
	'323': 'SUGARCANE_2024',
};
